
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"exclamation","xmlns":"http://www.w3.org/2000/svg","width":"18.345","height":"18.345"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_37645","data-name":"Path 37645","d":"M9.173 18.345A9.173 9.173 0 100 9.173a9.173 9.173 0 009.173 9.172zM8.408 4.586a.764.764 0 111.529 0V10.7a.764.764 0 01-1.529 0V4.586zm.764 9.173a.764.764 0 11-.764.764.764.764 0 01.765-.764z","fill":"#5858ec"}})])
          )
        }
      }
    